<template>
  <div class="list">
    <li v-for="(submeta, id) in submetas"
      :key="`submeta_${id}`"
      >
      {{submeta.meta}}
      <ol>
        <li v-for="(meta_meta, i) in submeta.acciones_especificas"
          :key="`meta_${i}`"
          >
          {{meta_meta}}
        </li>
      </ol>
    </li>
  </div>
</template>

<script>
export default {
  name: 'ListV2',
  props: {
    meta: {
      type: String,
      default: 'Accion'
    },
    submetas: {
      type: Array,
      default: () => []
    },
  }
}
</script>

<style lang="scss" scoped>
.list > li {
  color: #6F7271;
  font-size: 24px;
  font-weight: 400;
  &:hover {
    // background: #F5F5F5;
  }  
  ol > li {
    color: #000;
    font-size:16px;
    font-weight: 400;
  }
}
</style>